import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentIconTooltip',
  props: {
  id: {
    type: String as PropType<string>,
    required: true,
  },
  text: {
    type: String as PropType<string>,
    default: "",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_b_tooltip = _resolveComponent("b-tooltip")!

  return (_openBlock(), _createBlock(_component_b_tooltip, {
    class: _normalizeClass('assessment-icon-tooltip'),
    target: __props.id,
    title: __props.text
  }, null, 8, ["target", "title"]))
}
}

})